module.exports = __webpack_public_path__ + "img/3_dots_dark.0ac3be89.svg";